<template>
  <div>
    <edit-form ref="editForm" :disabled="isDisableEditForm" :params="params" />
    <div class="d-flex justify-content-end mb-2">
      <el-button
        @click="$refs.editForm.save()"
        type="primary"
        size="small"
        v-if="!isDisableEditForm"
        >保存</el-button
      >
    </div>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'system-sysuser-detail',
  components: {
    EditForm,
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
}
</script>
